export const SwimmingPoolIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 16.8236C4.06694 16.8236 6.36714 13.1177 6.36714 13.1177C6.36714 13.1177 8.66734 16.8236 11.7343 16.8236C14.8012 16.8236 17.8682 13.1177 17.8682 13.1177C17.8682 13.1177 20.935 16.8236 23.2353 16.8236"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 22.9998C4.06694 22.9998 6.36714 19.2939 6.36714 19.2939C6.36714 19.2939 8.66734 22.9998 11.7343 22.9998C14.8012 22.9998 17.8682 19.2939 17.8682 19.2939C17.8682 19.2939 20.935 22.9998 23.2353 22.9998"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.4707 11.2649L8.41188 8.17663L6.94566 6.34386C6.39611 5.65693 6.52374 4.65156 7.22751 4.12373C7.89121 3.62596 8.82853 3.73544 9.35964 4.37278L14.5883 10.6472"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6764 8.17647C19.3819 8.17647 20.7646 6.79381 20.7646 5.08823C20.7646 3.38265 19.3819 2 17.6764 2C15.9708 2 14.5881 3.38265 14.5881 5.08823C14.5881 6.79381 15.9708 8.17647 17.6764 8.17647Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
